/**
 * Utilitário de criptografia leve para senhas de Usuários VIP usando a Web Crypto API (SHA-256).
 */
export async function hashPassword(password: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(password + '_vip_salt_berenice_2026');
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}

export async function verifyPassword(password: string, storedHash: string): Promise<boolean> {
  const hashedInput = await hashPassword(password);
  return hashedInput === storedHash;
}
